export enum ContactType {
  MEETING = 'MEETING',
  PHONE_CALL = 'PHONE_CALL',
  EMAIL = 'EMAIL',
  CHAT = 'CHAT',
  EVENT = 'EVENT',
  LETTER = 'LETTER',
  FAX = 'FAX',
  OTHER = 'OTHER',
}

export type isActiveType = 'Y' | 'N' | null;

export type SelectOption = {
  value: string;
  label: string;
  isActive?: isActiveType;
  category?: string;
  type?: string;
};

export const ContactTypeOptions = [
  {
    value: ContactType.MEETING,
    label: 'Visit/ F2F meeting',
  },
  {
    value: ContactType.PHONE_CALL,
    label: 'Phone/ Video call',
  },

  {
    value: ContactType.EMAIL,
    label: 'Email',
  },
  {
    value: ContactType.CHAT,
    label: 'BJB Chat',
  },
  {
    value: ContactType.EVENT,
    label: 'Event',
  },
  {
    value: ContactType.LETTER,
    label: 'Letter',
  },
  {
    value: ContactType.FAX,
    label: 'Fax',
  },
  {
    value: ContactType.OTHER,
    label: 'Other (Please specify)',
  },
];

const contactTypes = { ContactTypeOptions, ContactTypeEnums: ContactType };
export default contactTypes;
